import { ChakraProvider, ColorModeScript, extendTheme } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter , RouterProvider, } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

import "./styles.css"

import NavBar from './components/NavBar';
import ErrorPage from "./error-page";
import Home from './routes/home';
import TermsConditions from './routes/termsConditions';
import AITeens from './routes/aiTeens'
import AIProf from './routes/aiProf';
import AISmallBusiness from "./routes/ai-smallBusiness";
import ApplyTo from './routes/apply';


import '@fontsource/barlow'

const theme = extendTheme({
  fonts: {
    heading: `'Barlow', sans-serif`,
    body: `'Barlow', sans-serif`,
  },
})

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const router = createBrowserRouter([
  {
    path: "/",
    element: <NavBar />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "AI-Teens",
        element: <AITeens />,
        errorElement: <ErrorPage />,
      },
      {
        path: "AI-Prof",
        element: <AIProf />,
        errorElement: <ErrorPage />,
      },
      {
        path: "AI-SmallBusiness",
        element: <AISmallBusiness />,
        errorElement: <ErrorPage />,
      },
      {
        path: "apply",
        element: <ApplyTo />,
        errorElement: <ErrorPage />,
      },
      {
        path: "termsandconditions",
        element: <TermsConditions />,
        errorElement: <ErrorPage />,
      },
    ],
  },
]);

root.render(
  <StrictMode>
    <ColorModeScript />
    <ChakraProvider theme={theme}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();